import * as applicationGraphql from './applications'
import * as userGraphql from './user'
const queries = Object.assign({}, applicationGraphql, userGraphql)
export default queries